import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- Vendor Apis ------------------------------
export const getVendors = createAsyncThunk(
    "getVendors",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getVendors, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const downloadVendor = createAsyncThunk(
    "downloadVendor",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.downloadVendor, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getVendorById = createAsyncThunk(
    "getVendorById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getVendorById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);

export const addVendor = createAsyncThunk(
    "addVendor",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addVendor, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateVendor = createAsyncThunk(
    "updateVendor",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateVendor, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const image = createAsyncThunk(
    "image",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.image, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
